import { GetStaticProps, NextPage } from 'next';
import AboutPage from '../../components/elements/AboutPage';
import PageLayout, { MenuProps } from '../../layouts/Page';
import { ABOUT_PAGE } from '../../queries/about';
import { AboutUs, AboutUsAboutDynamicDynamicZone, Testimony } from '../../types/schema';
import { initializeApollo } from '../../utils/apollo';
import { Error, sendError } from '../../utils/error';
import { flatten, translateProperty } from '../../utils/object';

type AboutUsProps = {
  data: AboutUs;
  testimonies: Testimony[];
  menus: MenuProps;
};

/**
 * Sobre NextPage
 */
const Sobre: NextPage<AboutUsProps> = ({ testimonies, data, menus }) => {
  const { aboutDynamic } = data;

  return (
    <PageLayout menus={menus} locale="pt" isHeaderTransparent>
      <AboutPage
        metaTitle={data?.metadata?.metaTitle as string}
        metaDescription={data?.metadata?.metaDescription as string}
        metaImage={(data?.metadata?.metaImage as unknown as { url?: string })?.url as string}
        hideAppMastersTitle={data?.metadata?.hideAppMastersTitle as boolean}
        title={data.title as string}
        description={data.body as string}
        bannerUrl={(data.banner as unknown as { url?: string })?.url || ''}
        aboutDynamic={aboutDynamic as AboutUsAboutDynamicDynamicZone[]}
        testimonies={testimonies}
      />
    </PageLayout>
  );
};

/**
 * getStaticProps
 */
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  if (locale === 'en') {
    return {
      notFound: true,
    };
  }

  try {
    const apolloClient = initializeApollo();

    const { data } = await apolloClient.query({
      query: ABOUT_PAGE,
      variables: {
        locale,
      },
    });

    const newData = flatten(data);

    const translatedObj = translateProperty(
      newData.aboutUs as AboutUs,
      ['background', 'backgroundColor', 'content'],
      'aboutDynamic',
    );

    return {
      props: {
        data: translatedObj as AboutUs,
        testimonies: newData.testimonies,
        menus: {
          header: newData.header,
          technologies: newData.technologies,
          services: newData.services,
          footerPt: newData.footerPt,
          footerEn: newData.footerEn,
        },
      },
    };
  } catch (error) {
    sendError({ error: error as Error, message: 'Error on sobre page' });
    return {
      notFound: true,
    };
  }
};

export default Sobre;
